import React from 'react';
import Preloader from 'components/Preloader/Preloader';
import DelayedLoad from 'components/Shared/DelayedLoad/DelayedLoad';

/**
 * DelayedPreloader - Spinner-flavored convenience wrapper around DelayedLoad:
 * shows the Preloader spinner only after a delay, and for a minimum duration
 * once shown. The timing logic now lives in DelayedLoad; new code that needs a
 * different indicator (e.g. a shimmer skeleton) should use DelayedLoad directly
 * with a render-prop child.
 *
 * Props:
 *   isLoading (bool) - Whether data is currently loading
 *   delay (number) - Ms to wait before showing loader (default: 700)
 *   minDuration (number) - Minimum ms to show loader once visible (default: 1000)
 *   isGray, compact, spinnerSize - Passed through to Preloader
 */
export default function DelayedPreloader(props) {
  return (
    <DelayedLoad isLoading={props.isLoading} delay={props.delay} minDuration={props.minDuration}>
      {function(visible) {
        return visible ? (
          <Preloader isGray={props.isGray} compact={props.compact} spinnerSize={props.spinnerSize} />
        ) : null;
      }}
    </DelayedLoad>
  );
}
